import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField/index';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import FormatListBulleted from 'material-ui/svg-icons/editor/format-list-bulleted';
import {
  disabledButtonTextGray,
  hintTextGrayColor,
  primaryBlue
} from 'theme/mainColors';

class TTSourceInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.sourceInput.listSize > 0 ? `${ props.sourceInput.listSize } ITEMS` : props.sourceInput.matchValue,
      showList: props.sourceInput.matchValue === '' || props.sourceInput.listSize > 0
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.sourceInput.listSize !== nextProps.sourceInput.listSize) {
      if (nextProps.sourceInput.listSize !== 0) {
        this.setState({
          value: nextProps.sourceInput.listSize > 0 ? `${ nextProps.sourceInput.listSize } ITEMS` : nextProps.sourceInput.matchValue,
          showList: nextProps.sourceInput.matchValue === ''
        });
      }
    }
  }

  handleTextFieldChange = (ev, value) => this.setState({ value, showList: value === '' });

  handleTextFieldBlur = ev => this.props.ttActions.updateSourceInputFieldData(this.props.sourceInput.id, ev.target.value);

  handleCloseButtonClick = () => this.props.onCloseClick();

  handleListButtonClick = () => this.props.onListClick();

  render() {
    const { displayClose, sourceInput } = this.props;
    const { value, showList } = this.state;
    const disabled = sourceInput.listSize > 0;
    return (
      <div className={ 'tt-source-input__main-container' }>
        <div className={ `tt-source-input__input-container ${ disabled ? 'tt-source-input__input-container_disabled': '' }` }>
          <TextField
            hintText="Input Data Value"
            value={ value }
            style={ { marginTop: -20 } }
            hintStyle={ { fontSize: 13, color: hintTextGrayColor } }
            inputStyle={ { fontSize: 13 } }
            underlineStyle={ { borderColor: disabledButtonTextGray } }
            underlineDisabledStyle={ { borderBottom: `1px solid ${ disabledButtonTextGray }` } }
            onChange={ this.handleTextFieldChange }
            onBlur={ this.handleTextFieldBlur }
            fullWidth={ true }
            disabled={ disabled }
          />
        </div>
        {
          displayClose &&
          <CloseIcon
            color={ hintTextGrayColor }
            hoverColor={ disabledButtonTextGray }
            onClick={ this.handleCloseButtonClick }
          />
        }
        {
          showList &&
          <FormatListBulleted
            color={ hintTextGrayColor }
            hoverColor={ primaryBlue }
            style={ { marginLeft: 0, paddingBottom: 2, height: 20, width: 20, cursor: 'pointer', borderBottomStyle: 'none !important', boxSizing: 'content-box' } }
            onClick={ this.handleListButtonClick }
          />
        }
      </div>
    );
  }
}

TTSourceInput.propTypes = {
  sourceColumn: PropTypes.object.isRequired,
  sourceInput: PropTypes.object.isRequired,
  displayClose: PropTypes.bool,
  onCloseClick: PropTypes.func,
  onListClick: PropTypes.func,
  sourceInputList: PropTypes.object,
  ttActions: PropTypes.shape({
    updateSourceInputFieldData: PropTypes.func
  }).isRequired,
  disabled: PropTypes.bool
};

TTSourceInput.defaultProps = {
  displayClose: false,
  onCloseClick: () => null,
  onListClick: () => null,
  sourceInputList: {},
  disabled: false
};

export default TTSourceInput;



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttRowManager/c/ttMainGrid/c/ttSourceInput/TTSourceInput.js